// extracted by mini-css-extract-plugin
var _1 = "description___DsUC";
export { _1 as "description" }
